module.exports = __webpack_public_path__ + "static/img/shzl.e23388a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/shzl.svg
// module id = sS7m
// module chunks = 0